import React from "react";
import { SEO, MainLayout, OrdersLayout } from "../../../components";

const MyOrdersPage = () => {
  return (
    <>
      <SEO title="orders" />
      <MainLayout>
        <OrdersLayout />
      </MainLayout>
    </>
  );
};

export default MyOrdersPage;
